export enum WorkflowEngine {
  ActivitiAmberfin = "ActivitiAmberfin",
  Elsa = "Elsa",
  Vantage = "Vantage",
  Kaliko = "Kaliko",
}
